export default __webpack_public_path__ + "469b27a5225321fc6d670abf3f1bf21d.png";